export const WEEKDAY_TRANSLATION_KEYS = [
  "common.weekdays.sunday",
  "common.weekdays.monday",
  "common.weekdays.tuesday",
  "common.weekdays.wednesday",
  "common.weekdays.thursday",
  "common.weekdays.friday",
  "common.weekdays.saturday",
];

export const getWeekdayLabel = (dayIndex, translate) => {
  const key =
    WEEKDAY_TRANSLATION_KEYS[dayIndex] ||
    WEEKDAY_TRANSLATION_KEYS[0];

  return translate(key);
};